import Skeleton from "@mui/material/Skeleton";

import {
    Avatar,
    Box,
    Card,
    Button,
    TextField,
    Typography,
    CardContent,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Container,
    Tabs,
    Tab,
} from "@mui/material";

import PortraitIcon from "@mui/icons-material/Portrait";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import SpeakerGroupIcon from "@mui/icons-material/SpeakerGroup";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ShareIcon from "@mui/icons-material/Share";
import AddIcon from "@mui/icons-material/Add";

import { config, styles } from "../../style/application";

import Grid from "@mui/material/Unstable_Grid2";

export const skeleton = (userDetails, isDesktop) => (
    <>
        <Container>
            {isDesktop && userDetails.applicant && (
                <Card
                    sx={{
                        padding: "20px",
                        background: "white",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "12px",
                        width: "100%",
                    }}
                >
                    <CardContent sx={{ width: "100%" }}>
                        <Grid sx={{ height: "100px" }} container justifyContent={"space-between"} alignItems={"center"}>
                            <Grid item sx={{ color: "#164C63" }}>
                                <Skeleton variant="rounded" width={300} height={40} />
                                <Skeleton sx={{ mt: "10px" }} variant="rounded" width={500} height={15} />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )}
            <Grid sx={{ width: "100%" }} container spacing={isDesktop ? 3 : 0}>
                <Grid sx={{ pl: { lg: "0" } }} item xs={12} lg={4}>
                    <Card sx={{ width: "100%", p: "0" }}>
                        <CardContent sx={{ width: "100%" }}>
                            {!isDesktop && (
                                <>
                                    <Tabs
                                        variant="scrollable"
                                        centered
                                        scrollButtons="auto"
                                        selectionFollowsFocus
                                        aria-label="scrollable auto tabs example"
                                        sx={{ display: "flex", justifyContent: "space-between" }}
                                    >
                                        <Tab
                                            sx={{
                                                borderBottom: "1px solid #EAECF0",
                                                background: "#FCFCFD",
                                                borderRight: "1px solid #EAECF0",
                                                borderLeft: "1px solid #EAECF0",
                                            }}
                                            icon={<Skeleton variant="rounded" width={20} height={20} />}
                                            label={
                                                <Skeleton sx={{ mt: "5px" }} variant="rounded" width={60} height={15} />
                                            }
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                borderBottom: "1px solid #EAECF0",
                                                background: "#FCFCFD",
                                                borderRight: "1px solid #EAECF0",
                                                borderLeft: "1px solid #EAECF0",
                                            }}
                                            icon={<Skeleton variant="rounded" width={20} height={20} />}
                                            label={
                                                <Skeleton sx={{ mt: "5px" }} variant="rounded" width={60} height={15} />
                                            }
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                borderBottom: "1px solid #EAECF0",
                                                background: "#FCFCFD",
                                                borderRight: "1px solid #EAECF0",
                                                borderLeft: "1px solid #EAECF0",
                                            }}
                                            icon={<Skeleton variant="rounded" width={20} height={20} />}
                                            label={
                                                <Skeleton sx={{ mt: "5px" }} variant="rounded" width={60} height={15} />
                                            }
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                borderBottom: "1px solid #EAECF0",
                                                background: "#FCFCFD",
                                                borderRight: "1px solid #EAECF0",
                                                borderLeft: "1px solid #EAECF0",
                                            }}
                                            icon={<Skeleton variant="rounded" width={20} height={20} />}
                                            label={
                                                <Skeleton sx={{ mt: "5px" }} variant="rounded" width={70} height={15} />
                                            }
                                        ></Tab>
                                    </Tabs>
                                </>
                            )}
                            {isDesktop && (
                                <>
                                    <Tabs
                                        variant="scrollable"
                                        centered
                                        scrollButtons="auto"
                                        selectionFollowsFocus
                                        aria-label="scrollable auto tabs example"
                                        orientation="vertical"
                                    >
                                        <Tab
                                            sx={{
                                                maxWidth: "100%",
                                                width: "100%",
                                                minHeight: "42px",
                                                justifyContent: "start",
                                                borderBottom: "1px solid #EAECF0",
                                                borderRight: "1px solid white",
                                                borderLeft: "1px solid white",
                                                padding: "12px 15px 6px 15px",
                                            }}
                                            iconPosition="start"
                                            icon={<Skeleton variant="rounded" width={15} height={15} />}
                                            label={<Skeleton variant="rounded" width={120} height={15} />}
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                maxWidth: "100%",
                                                width: "100%",
                                                minHeight: "42px",
                                                justifyContent: "start",
                                                borderBottom: "1px solid #EAECF0",
                                                borderRight: "1px solid white",
                                                borderLeft: "1px solid white",
                                                padding: "12px 15px 6px 15px",
                                            }}
                                            iconPosition="start"
                                            icon={<Skeleton variant="rounded" width={15} height={15} />}
                                            label={<Skeleton variant="rounded" width={150} height={15} />}
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                maxWidth: "100%",
                                                width: "100%",
                                                minHeight: "42px",
                                                justifyContent: "start",
                                                borderBottom: "1px solid #EAECF0",
                                                borderRight: "1px solid white",
                                                borderLeft: "1px solid white",
                                                padding: "12px 15px 6px 15px",
                                            }}
                                            iconPosition="start"
                                            icon={<Skeleton variant="rounded" width={15} height={15} />}
                                            label={<Skeleton variant="rounded" width={90} height={15} />}
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                maxWidth: "100%",
                                                width: "100%",
                                                minHeight: "42px",
                                                justifyContent: "start",
                                                borderBottom: "1px solid #EAECF0",
                                                borderRight: "1px solid white",
                                                borderLeft: "1px solid white",
                                                padding: "12px 15px 6px 15px",
                                            }}
                                            iconPosition="start"
                                            icon={<Skeleton variant="rounded" width={15} height={15} />}
                                            label={<Skeleton variant="rounded" width={110} height={15} />}
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                maxWidth: "100%",
                                                width: "100%",
                                                minHeight: "42px",
                                                justifyContent: "start",
                                                borderBottom: "1px solid #EAECF0",
                                                borderRight: "1px solid white",
                                                borderLeft: "1px solid white",
                                                padding: "12px 15px 6px 15px",
                                            }}
                                            iconPosition="start"
                                            icon={<Skeleton variant="rounded" width={15} height={15} />}
                                            label={<Skeleton variant="rounded" width={90} height={15} />}
                                        ></Tab>
                                        <Tab
                                            sx={{
                                                maxWidth: "100%",
                                                width: "100%",
                                                minHeight: "42px",
                                                justifyContent: "start",
                                                borderBottom: "1px solid #EAECF0",
                                                borderRight: "1px solid white",
                                                borderLeft: "1px solid white",
                                                padding: "12px 15px 6px 15px",
                                            }}
                                            iconPosition="start"
                                            icon={<Skeleton variant="rounded" width={15} height={15} />}
                                            label={<Skeleton variant="rounded" width={80} height={15} />}
                                        ></Tab>
                                    </Tabs>
                                </>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid sx={{ pr: "0" }} item xs={12} lg={8}>
                    <Card sx={{ width: "100%", p: "16px", mt: { xs: "16px", lg: "0px" } }}>
                        <CardContent sx={{ width: "100%" }}>
                            <Skeleton variant="rounded" width={300} height={15} />
                            <Skeleton sx={{ mt: "15px" }} variant="rounded" width={"100%"} height={100} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    </>
);
